/* ============================================
   GLOSSY WOODS - Main Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  // ============================================
  // SCROLL REVEAL ANIMATION
  // ============================================
  function initScrollReveal() {
    var elements = document.querySelectorAll('.reveal-section, .reveal-card');
    
    if (!window.IntersectionObserver) {
      elements.forEach(function(el) { el.classList.add('visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    elements.forEach(function(el) { observer.observe(el); });
  }
  initScrollReveal();

  // ============================================
  // SCROLL TO TOP
  // ============================================
  var scrollBtn = document.getElementById('scrollToTop');
  if (scrollBtn) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 400) {
        scrollBtn.classList.add('visible');
      } else {
        scrollBtn.classList.remove('visible');
      }
    }, { passive: true });

    scrollBtn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ============================================
  // COOKIE NOTICE
  // ============================================
  function initCookieNotice() {
    var notice = document.getElementById('cookieNotice');
    if (!notice) return;
    var consent = localStorage.getItem('tm_cookies_accepted');
    // Show only if user has not yet made a choice
    if (!consent) {
      setTimeout(function() { notice.classList.add('show'); }, 1800);
    }
  }
  initCookieNotice();

  // ============================================
  // TOAST NOTIFICATION
  // ============================================
  window.showToast = function(message, type) {
    type = type || 'default';
    var existing = document.querySelector('.tm-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'tm-toast ' + type;
    toast.innerHTML = (type === 'success' ? '✓ ' : '') + message;
    document.body.appendChild(toast);

    setTimeout(function() { toast.classList.add('show'); }, 10);
    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() { toast.remove(); }, 350);
    }, 3500);
  };

  // ============================================
  // PRODUCT GALLERY THUMBNAILS
  // ============================================
  function initProductGallery() {
    // Deliberately left empty — gallery is handled by
    // the inline selectThumb() function in main-product.liquid
    // to avoid double-binding and blur conflicts.
  }
  initProductGallery();

  // ============================================
  // PRODUCT ACCORDION
  // ============================================
  function initAccordion() {
    var triggers = document.querySelectorAll('.tm-accordion-trigger');
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = this.closest('.tm-accordion-item');
        var body = item.querySelector('.tm-accordion-body');
        var isOpen = item.classList.contains('open');

        // Close all
        document.querySelectorAll('.tm-accordion-item').forEach(function(i) {
          i.classList.remove('open');
          var b = i.querySelector('.tm-accordion-body');
          if (b) b.classList.remove('open');
        });

        // Toggle current
        if (!isOpen) {
          item.classList.add('open');
          body.classList.add('open');
        }
      });
    });
  }
  initAccordion();

  // ============================================
  // QUANTITY SELECTOR
  // ============================================
  function initQuantitySelectors() {
    document.querySelectorAll('.tm-qty-selector').forEach(function(selector) {
      var input = selector.querySelector('.tm-qty-input');
      var minus = selector.querySelector('[data-action="minus"]');
      var plus  = selector.querySelector('[data-action="plus"]');
      if (!input) return;

      if (minus) minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          if (typeof window.tmUpdateQtyPrice === 'function') window.tmUpdateQtyPrice(val - 1);
        }
      });
      if (plus) plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
        if (typeof window.tmUpdateQtyPrice === 'function') window.tmUpdateQtyPrice(val + 1);
      });
    });
  }
  initQuantitySelectors();

  // ============================================
  // CART OPERATIONS
  // ============================================
  window.addToCart = function(variantId, btn, qty) {
    qty = qty || 1;
    var originalContent = btn.innerHTML;
    btn.innerHTML = '<span class="tm-spinner"></span>';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) {
        showToast(data.description || 'Could not add item', 'error');
        btn.innerHTML = originalContent;
        btn.disabled = false;
      } else {
        btn.innerHTML = '✓ Added!';
        btn.style.background = '#27ae60';
        updateCartCount();
        showToast('Item added to cart!', 'success');
        var cartEl = document.getElementById('cartCount');
        if (cartEl) { cartEl.classList.add('cart-bounce'); setTimeout(function() { cartEl.classList.remove('cart-bounce'); }, 500); }
        setTimeout(function() {
          btn.innerHTML = originalContent;
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
      }
    })
    .catch(function() {
      showToast('Something went wrong. Please try again.', 'error');
      btn.innerHTML = originalContent;
      btn.disabled = false;
    });
  };

  window.updateCartCount = function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var el = document.getElementById('cartCount');
        if (el) el.textContent = cart.item_count;
      });
  };

  // ============================================
  // WISHLIST (LOCAL STORAGE) — key: tm_wish
  // Stores product handles (e.g. 'smart-led-light')
  // ============================================
  window.toggleWishlist = function(handle, btn) {
    var wishlist = JSON.parse(localStorage.getItem('tm_wish') || '[]');
    var idx = wishlist.indexOf(String(handle));
    if (idx > -1) {
      wishlist.splice(idx, 1);
      if (btn) { btn.style.color = ''; btn.style.background = ''; }
      showToast('Removed from wishlist');
    } else {
      wishlist.push(String(handle));
      if (btn) { btn.style.color = '#e74c3c'; btn.style.background = 'rgba(231,76,60,0.08)'; }
      showToast('Added to wishlist ♥ — <a href="/pages/wishlist" style="color:#C9A84C;text-decoration:underline;">View</a>');
    }
    localStorage.setItem('tm_wish', JSON.stringify(wishlist));
    // Update header badge
    var badge = document.getElementById('wlHeaderCount');
    if (badge) {
      badge.textContent = wishlist.length > 9 ? '9+' : wishlist.length;
      badge.style.display = wishlist.length > 0 ? 'flex' : 'none';
    }
  };

  // ============================================
  // ANIMATED COUNTER
  // ============================================
  function animateCounter(el, target, duration) {
    duration = duration || 1500;
    var start = 0;
    var suffix = el.dataset.suffix || '';
    var increment = target / (duration / 16);

    var timer = setInterval(function() {
      start += increment;
      if (start >= target) {
        el.textContent = target + suffix;
        clearInterval(timer);
      } else {
        el.textContent = Math.floor(start) + suffix;
      }
    }, 16);
  }

  var counters = document.querySelectorAll('[data-counter]');
  if (counters.length && window.IntersectionObserver) {
    var counterObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var target = parseInt(entry.target.dataset.counter);
          animateCounter(entry.target, target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(function(c) { counterObserver.observe(c); });
  }

  // ============================================
  // PROGRESS BARS ANIMATION
  // ============================================
  var progressBars = document.querySelectorAll('.progress-fill');
  if (progressBars.length && window.IntersectionObserver) {
    var barObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          barObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    progressBars.forEach(function(b) { barObserver.observe(b); });
  }

  // ============================================
  // SEARCH KEYBOARD SHORTCUT
  // ============================================
  document.addEventListener('keydown', function(e) {
    if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
      e.preventDefault();
      toggleSearch();
    }
    if (e.key === 'Escape') {
      var bar = document.getElementById('searchBar');
      if (bar && bar.classList.contains('active')) {
        bar.classList.remove('active');
      }
    }
  });

  // ============================================
  // LAZY LOAD IMAGES
  // ============================================
  if ('loading' in HTMLImageElement.prototype) {
    // Native lazy loading supported
  } else {
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    if (window.IntersectionObserver) {
      var lazyObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            img.src = img.dataset.src || img.src;
            lazyObserver.unobserve(img);
          }
        });
      });
      lazyImages.forEach(function(img) { lazyObserver.observe(img); });
    }
  }

});

// ============================================
// COOKIE CONSENT FUNCTIONS (global)
// ============================================
function acceptCookies() {
  localStorage.setItem('tm_cookies_accepted', '1');
  var notice = document.getElementById('cookieNotice');
  if (notice) {
    notice.classList.remove('show');
    setTimeout(function() { notice.style.display = 'none'; }, 450);
  }
  // Fire Meta Pixel immediately on accept
  if (typeof tmInitPixel === 'function') {
    tmInitPixel();
  }
  // Fire standard Pixel events for current page context
  if (typeof fbq === 'function') {
    fbq('track', 'PageView');
    // Track ViewContent if on a product page
    var pdTitle = document.querySelector('.tm-product-heading');
    if (pdTitle) {
      fbq('track', 'ViewContent', {
        content_name: pdTitle.textContent.trim(),
        content_type: 'product'
      });
    }
  }
}

function declineCookies() {
  // Store decline — do not fire pixel
  localStorage.setItem('tm_cookies_accepted', '0');
  var notice = document.getElementById('cookieNotice');
  if (notice) {
    notice.classList.remove('show');
    setTimeout(function() { notice.style.display = 'none'; }, 450);
  }
}

// ============================================
// TOGGLE SEARCH (global)
// ============================================
function toggleSearch() {
  var bar = document.getElementById('searchBar');
  if (!bar) return;
  bar.classList.toggle('active');
  if (bar.classList.contains('active')) {
    bar.querySelector('input') && bar.querySelector('input').focus();
  }
}
